export const AUTH_COOKIE_NAME = "auth-session";

export const PROVIDER_ERRORS = [
  "auth/account-exists-with-different-credential",
  "auth/cancelled-popup-request",
  "auth/popup-closed-by-user",
] as const;

export const USER_REQUIRES_REAUTH = "auth/requires-recent-login";

export const MAX_PREAUTH_RETRIES = 3;

export const RECOVERY_ATTEMPTS_STORAGE_KEY = "auth_recovery_attempts";
export const REAUTH_SUCCESS_STORAGE_KEY = "auth_reauth_success";
export const GUEST_WISHLIST_MERGED_STORAGE_KEY = "wishlist_guest_merged";
export const MAX_RECOVERY_REFRESH_ATTEMPTS = 2;
